import angular from 'angular';

import { DraftInvoice } from '../../invoicing/model/draftInvoice';
import { InvoiceLine } from '../../invoicing/model/invoiceLine';
import { Registration } from '../../registrations/model/registration';
import { BillableRegistration } from '../../invoicing/model/billableRegistration';
import { Invoice } from '../../invoicing/model/invoice';
import { castJSON } from '../../helpers';
import utils from '@/shared/utils/adminpulse';
import moment from 'moment';

angular
  .module('commonServices')
  .factory('resourceFactorySvc', ['$resource', '$http', 'appUrls', resourceFactorySvc]);

function resourceFactorySvc($resource, $http, appUrls) {
  var wrapResponse = function() {
    return [
      function(data, headers, status) {
        //Only wrap if request was successfull
        if (status === 200)
          return {
            result: JSON.parse(data),
          };
        return data;
      },
    ].concat($http.defaults.transformResponse);
  };

  var castResponse = function(type) {
    return [].concat($http.defaults.transformResponse, [
      function(data, headers, status) {
        if (status !== 200) return data;
        return castJSON(data, type);
      },
    ]);
  };

  var fileResponse = function() {
    return function(data, headers, status) {
      //Only wrap if request was successfull
      if (status !== 200) {
        return angular.fromJson(String.fromCharCode.apply(null, new Uint8Array(data)));
      }

      var headers = headers();

      var fileType = headers['content-type'];
      var blob = null;
      if (data)
        blob = new Blob(
          [data],
          fileType
            ? {
                type: fileType,
              }
            : {},
        );
      var fileName = utils.getFileNameFromHeader(headers['content-disposition']);
      return {
        blob: blob,
        fileName: fileName,
        headers: headers,
      };
    };
  };

  function transformRegistration(data) {
    for (var i = 0; i < data.length; i++) {
      data[i].date2 = data[i].date;
      data[i].date =
        data[i].date.getFullYear() +
        '-' +
        (data[i].date.getMonth() + 1) +
        '-' +
        data[i].date.getDate();
    }

    var result = JSON.stringify(data);

    for (var j = 0; j < data.length; j++) {
      //TFS 5323
      data[j].date = data[j].date2;
    }

    return result;
  }

  var dateTimeRegex = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?Z?/;
  var dateRegex = /^(\d{4}-\d{1,2}-\d{1,2})(T0+:0+:0+)?$/;

  var transformDate = function(value) {
    var match;
    var matchDate;
    // Check for string properties which look like dates.
    if (typeof value === 'string' && (match = value.match(dateTimeRegex))) {
      var milliseconds;
      if ((matchDate = value.match(dateRegex)))
        milliseconds = moment.utc(matchDate[1]).utcOffset(0);
      else milliseconds = Date.parse(match[0]);
      if (!isNaN(milliseconds)) {
        return new Date(milliseconds);
      }
    }
    return null;
  };

  var setDatePropsToISO = function(input) {
    // Ignore things that aren't objects.
    if (typeof input !== 'object') return input;

    for (var key in input) {
      if (!input.hasOwnProperty(key)) continue;
      if (key.substr(0, 1) === '$') continue; //Ignore angular properties & promises
      var value = input[key];
      if (typeof value === 'undefined' || value === null) continue;
      if (typeof value === 'string') continue;
      if (value instanceof Date) input[key] = value.ISO();
      else if (typeof value === 'object') setDatePropsToISO(value);
    }
    return input;
  };

  var convertDateStringsToDates = function() {
    var transform = function(input) {
      // Ignore things that aren't objects.
      if (typeof input !== 'object') return input;

      for (var key in input) {
        if (!input.hasOwnProperty(key)) continue;

        var value = input[key];
        var match;
        var matchDate;
        // Check for string properties which look like dates.
        if (typeof value === 'string' && (match = value.match(dateTimeRegex))) {
          var milliseconds;
          if ((matchDate = value.match(dateRegex))) milliseconds = Date.parse(matchDate[1]);
          else milliseconds = Date.parse(match[0]);
          if (!isNaN(milliseconds)) {
            input[key] = new Date(milliseconds);
          }
        } else if (typeof value === 'object') {
          // Recurse into object
          transform(value);
        }
      }
      return input;
    };

    return [].concat($http.defaults.transformResponse, [transform]);
  };

  var convertDateToString = function() {
    var transform = function(input) {
      return setDatePropsToISO(input);
    };
    return [].concat([transform], $http.defaults.transformRequest);
  };

  var convertDateToUtcString = function() {
    var transform = function(input) {
      for (const key in input) {
        const value = input[key];
        if (value instanceof Date) {
          input[key] = moment
            .utc(input[key])
            .utcOffset(0)
            .toISOString(false)
            .substr(0, 10);
        }
      }
      return setDatePropsToISO(input);
    };
    return [].concat([transform], $http.defaults.transformRequest);
  };

  // Swith statement with strings: these strings are used in dataCache
  var getResource = function(type) {
    switch (type) {
      case 'address': {
        return $resource(appUrls.api + '/api/address/:id', null, {
          update: {
            method: 'PUT',
          },
          save: {
            method: 'POST',
          },
          delete: {
            method: 'DELETE',
          },
          mailSuggestions: {
            method: 'GET',
            url: appUrls.api + '/api/address/MailSuggestions/:id',
            isArray: true,
          },
        });
      }
      case 'commSetting': {
        return $resource(appUrls.api + '/api/communicationsetting', null, {
          update: {
            method: 'PUT',
          },
          save: {
            method: 'POST',
          }, // , transformResponse: function (data) { return { id: data.replace(/"/g, '') }; }
        });
      }
      case 'company': {
        return $resource(appUrls.api + '/api/company/:action', null, {
          getAll: {
            method: 'GET',
            params: {
              action: 'GetAll',
            },
            isArray: true,
          },
          update: {
            method: 'PUT',
            params: {
              action: 'Put',
            },
          },
          deleteFile: {
            method: 'DELETE',
            params: {
              action: 'Delete',
            },
          },
        });
      }
      case 'country': {
        return $resource(appUrls.api + '/api/country', null, {});
      }
      case 'currency': {
        return $resource(appUrls.api + '/api/currency', null, {});
      }
      case 'employee': {
        return $resource(appUrls.api + '/api/employee/:action', null, {
          query: {
            method: 'GET',
            params: {
              action: 'Get',
            },
            isArray: true,
            cancellable: true,
          },
          get: {
            method: 'GET',
            url: appUrls.api + '/api/employee/:id',
            params: {
              id: '00000000-0000-0000-0000-000000000000',
            },
          },
          getProfile: {
            method: 'GET',
            url: appUrls.api + '/api/employee/profile',
          },
          create: {
            method: 'POST',
            params: {
              action: 'Create',
            },
            isArray: false,
          },
          update: {
            method: 'PUT',
            params: {
              action: 'PUT',
            },
            transformRequest: convertDateToString(),
          },
          updateMyProfile: {
            method: 'PUT',
            params: {
              action: 'profile',
            },
          },
          registration: {
            method: 'GET',
            params: {
              action: 'Registration',
            },
            isArray: true,
          },
          delete: {
            method: 'DELETE',
            params: {
              action: 'Delete',
            },
            isArray: false,
          },
          undelete: {
            method: 'DELETE',
            params: {
              action: 'Undelete',
            },
            isArray: false,
          },
          updateTeams: {
            method: 'PUT',
            url: appUrls.api + '/api/employee/UpdateEmployeeTeams?id=:id',
            params: {},
          },
          updateTags: {
            method: 'PUT',
            url: appUrls.api + '/api/employee/tags?id=:id',
            params: {},
            isArray: true,
          },
          updateProfile: {
            method: 'PUT',
            url: appUrls.api + '/api/employee/UpdateProfile',
            params: {},
            isArray: false,
          },
          setHidden: {
            method: 'PUT',
            url: appUrls.api + '/api/employee/Hidden/:id/:hidden',
            params: {},
            isArray: false,
          },
        });
      }
      case 'employeeProfile': {
        return $resource(appUrls.api + '/api/employeeProfile/:action/:id', null, {
          query: {
            method: 'GET',
            params: {
              action: 'Get',
            },
            isArray: true,
          },
          overview: {
            method: 'GET',
            params: {
              action: 'Overview',
            },
            isArray: true,
          },
          update: {
            method: 'PUT',
          },
          post: {
            method: 'POST',
          },
          delete: {
            method: 'DELETE',
            params: {
              action: 'Delete',
            },
          },
          setDefault: {
            method: 'PUT',
            params: {
              action: 'SetDefault',
            },
            isArray: true,
          },
        });
      }
      case 'field': {
        return $resource(
          appUrls.api + '/api/field/:action',
          {
            action: 'Get',
          },
          {
            update: {
              method: 'PUT',
              params: {
                action: 'Put',
              },
            },
            save: {
              method: 'POST',
              params: {
                action: 'Post',
              },
            },
            delete: {
              method: 'DELETE',
              params: {
                action: 'Delete',
              },
            },
          },
        );
      }
      case 'fieldRequired': {
        return $resource(appUrls.api + '/api/field/required', null, {
          wizard: {
            method: 'GET',
            url: appUrls.api + '/api/field/wizard',
            isArray: true,
          },
        });
      }
      case 'kbo':
      case 'KBO': {
        return $resource(
          'api/KBO/:action/:id',
          {
            action: 'Get',
          },
          {
            search: {
              method: 'GET',
              params: {
                action: 'Search',
              },
              isArray: true,
            },
            copy: {
              method: 'GET',
              params: {
                action: 'Copy',
              },
              isArray: false,
            },
          },
        );
      }
      case 'language': {
        return $resource(appUrls.api + '/api/language', null, {
          ignoreLoadingBar: true,
        });
      }
      case 'link': {
        return $resource(appUrls.api + '/api/link', null, {
          update: {
            method: 'PUT',
          },
        });
      }
      case 'relationLink': {
        return $resource(appUrls.api + '/api/relationlink/:action/:id', null, {
          get: {
            method: 'GET',
            params: {
              action: 'Get',
            },
            isArray: true,
          },
          update: {
            method: 'PUT',
            params: {
              action: 'Put',
            },
          },
          save: {
            method: 'POST',
          },
          delete: {
            method: 'DELETE',
            params: {
              action: 'Delete',
            },
          },
          getDetails: {
            method: 'GET',
            params: {
              action: 'Details',
            },
            transformResponse: convertDateStringsToDates(),
          },
          updateDetails: {
            method: 'PUT',
            params: {
              action: 'UpdateDetails',
            },
            transformResponse: convertDateStringsToDates(),
          },
          shareholderGroups: {
            method: 'GET',
            params: {
              action: 'ShareholderGroups',
            },
            isArray: true,
          },
          linkInfo: {
            method: 'GET',
            params: {
              action: 'LinkInfo',
            },
            transformResponse: convertDateStringsToDates(),
          },
        });
      }
      case 'linkType': {
        return $resource(appUrls.api + '/api/link', null, {});
      }
      case 'registration': {
        return $resource(
          appUrls.api + '/api/registration/:action/:id',
          {
            action: 'Get',
          },
          {
            query: {
              method: 'GET',
              params: {
                action: 'Get',
              },
              cancellable: true,
            },
            kpi: {
              method: 'GET',
              params: {
                action: 'kpi',
              },
              cancellable: true,
            },
            update: {
              method: 'PUT',
              params: {
                action: 'Put',
              },
              isArray: true,
              transformRequest: transformRegistration,
            },
            save: {
              method: 'POST',
              params: {
                action: 'Post',
              },
              isArray: true,
              transformRequest: transformRegistration,
            },
            delete: {
              method: 'DELETE',
              params: {
                action: 'Delete',
              },
            },
            report: {
              method: 'GET',
              params: {
                action: 'Report',
              },
            },
            toggleNeverInvoice: {
              method: 'PUT',
              params: { action: 'NeverInvoice' },
              isArray: false,
            },
            toggleBillable: {
              method: 'PUT',
              params: { action: 'Billable' },
              isArray: false,
            },
            toggleInForfait: {
              method: 'PUT',
              params: { action: 'InForfait' },
              isArray: false,
            },
            calcDurationInDays: {
              method: 'POST',
              params: { action: 'CalcDurationInDays' },
              isArray: true,
              cancellable: true,
            },
          },
        );
      }
      case 'resource': {
        return $resource(appUrls.api + '/api/resource/:action/:id/:id2', null, {
          reg: {
            method: 'GET',
            params: {
              action: 'Registration',
              type: -1,
            },
            isArray: true,
            cancellable: true,
          },
          names: {
            method: 'GET',
            params: {
              action: 'Names',
              type: -1,
            },
            isArray: true,
          },
          updateResource: {
            method: 'PUT',
            params: {
              action: 'Put',
            },
          },
          updateCategory: {
            method: 'PUT',
            params: {
              action: 'UpdateCategory',
            },
          },
          updatePrice: {
            method: 'PUT',
            params: {
              action: 'Price',
            },
          },
          saveResource: {
            method: 'POST',
            params: {
              action: 'Post',
            },
          },
          saveCategory: {
            method: 'POST',
            params: {
              action: 'CreateCategory',
            },
          },
          deleteResource: {
            method: 'POST',
            params: {
              action: 'DeleteResource',
            },
            isArray: false,
            transformResponse: wrapResponse(),
          },
          deleteCategory: {
            method: 'POST',
            params: {
              action: 'DeleteCategory',
            },
            isArray: false,
            transformResponse: wrapResponse(),
          },
          restoreResource: {
            method: 'GET',
            url: appUrls.api + '/api/resource/restoreResource?id=:id',
          },
          restoreCategory: {
            method: 'GET',
            url: appUrls.api + '/api/resource/RestoreCategory?id=:id',
            isArray: false,
          },
          subresources: {
            method: 'GET',
            params: {
              action: 'ResourcesInCategory',
            },
            isArray: true,
          },
          tags: {
            method: 'GET',
            params: {
              action: 'Tags',
            },
            isArray: true,
          },
          priceOptions: {
            method: 'GET',
            params: {
              action: 'PriceOptions',
            },
          },
        });
      }
      case 'team': {
        return $resource(appUrls.api + '/api/team/:action/:id', null, {
          flatTeams: {
            method: 'GET',
            params: {
              action: 'flatTeams',
            },
            isArray: true,
          },
          myTeams: {
            method: 'GET',
            params: {
              action: 'myTeams',
            },
            isArray: true,
          },
        });
      }
      case 'price': {
        return $resource(appUrls.api + '/api/price/:action/:id', null, {
          update: {
            method: 'PUT',
            params: {
              action: 'Put',
            },
            transformResponse: convertDateStringsToDates(),
            transformRequest: convertDateToString(),
          },
          save: {
            method: 'POST',
            params: {
              action: 'Post',
            },
            transformResponse: convertDateStringsToDates(),
            transformRequest: convertDateToString(),
          },
          delete: {
            method: 'DELETE',
            params: {
              action: 'Delete',
            },
          },
          setTags: {
            method: 'PUT',
            params: {
              action: 'Tags',
            },
          },
        });
      }
      case 'discount': {
        return $resource(appUrls.api + '/api/discount/:action/:id', null, {
          update: {
            method: 'PUT',
            params: {
              action: 'Put',
            },
            transformResponse: convertDateStringsToDates(),
            transformRequest: convertDateToString(),
          },
          save: {
            method: 'POST',
            params: {
              action: 'Post',
            },
            transformResponse: convertDateStringsToDates(),
            transformRequest: convertDateToString(),
          },
          delete: {
            method: 'DELETE',
            params: {
              action: 'Delete',
            },
          },
          addTag: {
            method: 'GET',
            params: {
              action: 'Add',
            },
          },
          removeTag: {
            method: 'GET',
            params: {
              action: 'Remove',
            },
          },
        });
      }
      case 'relation': {
        return $resource(
          appUrls.api + '/api/Relation/:action/',
          {
            action: 'Get',
          },
          {
            get: {
              method: 'GET',
              params: {
                action: 'Get',
              },
              isArray: false,
              transformResponse: convertDateStringsToDates(),
            },
            getData: {
              method: 'POST',
              params: {
                action: 'Data',
              },
              isArray: false,
              transformResponse: convertDateStringsToDates(),
            },
            update: {
              method: 'PUT',
              params: {
                action: 'Put',
              },
              isArray: false,
              transformRequest: convertDateToString(),
              transformResponse: convertDateStringsToDates(),
            },
            list: {
              method: 'GET',
              params: {
                action: 'List',
              },
              isArray: true,
            },
            names: {
              method: 'GET',
              params: {
                action: 'Names',
                searchValue: '',
                includeInactive: false,
                crmTypes: [],
                type: null,
                take: 20,
              },
              isArray: true,
              cancellable: true,
            },
            ids: {
              method: 'POST',
              params: {
                action: 'Names',
              },
              isArray: true,
            },
            save: {
              method: 'POST',
              params: {
                action: 'Create',
              },
              isArray: false,
            },
            delete: {
              method: 'DELETE',
              params: {
                action: 'Delete',
              },
              isArray: false,
              transformResponse: wrapResponse(),
            },
            undelete: {
              method: 'DELETE',
              params: {
                action: 'Undelete',
              },
              url: appUrls.api + '/api/Relation/:action/:id',
            },
            changeType: {
              method: 'PUT',
              params: {
                action: 'Type',
              },
              isArray: false,
              transformRequest: convertDateToString(),
            },
            sections: {
              method: 'GET',
              params: { action: 'sections' },
              isArray: true,
            },
            employees: {
              method: 'GET',
              isArray: true,
              url: appUrls.api + '/api/Relation/Employees/:id',
            },
          },
        );
      }
      case 'settings': {
        return $resource(
          appUrls.api + '/api/settings/:action',
          {
            action: 'Get',
          },
          {
            query: {
              isArray: false,
            },
            update: {
              method: 'PUT',
              params: {
                action: 'PUT',
              },
            },
            company: {
              method: 'GET',
              params: {
                action: 'Company',
              },
              transformResponse: convertDateStringsToDates(),
            },
            hrm: {
              method: 'GET',
              params: {
                action: 'hrm',
              },
              transformResponse: convertDateStringsToDates(),
            },
            saveCompany: {
              method: 'PUT',
              params: {
                action: 'Company',
              },
              transformResponse: convertDateStringsToDates(),
              transformRequest: convertDateToString(),
            },
            saveHrm: {
              method: 'PUT',
              params: {
                action: 'hrm',
              },
              transformResponse: convertDateStringsToDates(),
              transformRequest: convertDateToString(),
            },
            deleteAttachment: {
              method: 'DELETE',
              params: {
                action: 'DeleteInvoiceAttachment',
              },
            },
          },
        );
      }
      case 'section': {
        return $resource(
          appUrls.api + '/api/section/:action',
          {
            action: 'Get',
          },
          {
            update: {
              method: 'PUT',
              params: {
                action: 'Put',
              },
            },
            save: {
              method: 'POST',
              params: {
                action: 'Post',
              },
            },
            delete: {
              method: 'DELETE',
              params: {
                action: 'Delete',
              },
            },
          },
        );
      }
      case 'sectionConfig': {
        return $resource(
          appUrls.api + '/api/SectionConfiguration/:action',
          {
            action: 'Get',
          },
          {
            update: {
              method: 'PUT',
              params: {
                action: 'Put',
              },
            },
            save: {
              method: 'POST',
              params: {
                action: 'Post',
              },
            },
            delete: {
              method: 'DELETE',
              params: {
                action: 'Delete',
              },
            },
          },
        );
      }
      case 'user': {
        return $resource(
          appUrls.api + '/api/user/:action',
          {
            action: 'all',
          },
          {
            reset: {
              method: 'GET',
              url: appUrls.api + '/api/user/:action/:id',
              params: {
                action: 'reset',
                id: '00000000-0000-0000-0000-000000000000',
              },
            },
            delete: {
              method: 'DELETE',
              url: appUrls.api + '/api/user/:id',
              params: {
                id: '00000000-0000-0000-0000-000000000000',
              },
            },
            create: {
              method: 'POST',
              url: appUrls.api + '/api/user',
            },
            forgotPassword: {
              method: 'GET',
              url: appUrls.api + '/api/user/:action',
              params: {
                action: 'forgotPassword',
                username: '',
              },
            },
            changePassword: {
              method: 'POST',
              params: {
                action: 'changePassword',
              },
            },
            get2FA: {
              method: 'POST',
              url: appUrls.api + '/api/user/:action',
              params: {
                action: 'get2fa',
              },
            },
            enable2FA: {
              method: 'POST',
              url: appUrls.api + '/api/user/:action',
              params: {
                action: 'Enable2FA',
              },
            },
            disable2FA: {
              method: 'POST',
              url: appUrls.api + '/api/user/:action',
              params: {
                action: 'Disable2FA',
              },
            },
            changeUsername: {
              method: 'POST',
              params: {
                action: 'changeUsername',
              },
            },
            language: {
              method: 'PUT',
              params: {
                action: 'language',
              },
            },
          },
        );
      }

      case 'invoice': {
        return $resource(
          appUrls.api + '/api/Invoice/:action',
          {
            action: 'Get',
          },
          {
            query: {
              method: 'GET',
              params: {
                action: 'Get',
              },
              isArray: true,
              transformResponse: castResponse(Invoice),
              cancellable: true,
            },
            lines: {
              method: 'GET',
              params: {
                action: 'Lines',
              },
              isArray: false,
              cancellable: true,
            },
            update: {
              method: 'PUT',
              params: {
                action: 'Put',
              },
            },
            info: {
              method: 'GET',
              params: {
                action: 'Info',
              },
              isArray: false,
              ignoreLoadingBar: true,
              cancellable: true,
            },
            topcustomerdebt: {
              method: 'GET',
              params: {
                action: 'TopCustomerDebt',
              },
              ignoreLoadingBar: true,
            },
            topcustomerbillable: {
              method: 'GET',
              params: {
                action: 'TopCustomerBillable',
              },
              ignoreLoadingBar: true,
            },
            topcustomerrevenue: {
              method: 'GET',
              params: {
                action: 'TopCustomerRevenue',
              },
              ignoreLoadingBar: true,
            },
            billedpermonth: {
              method: 'GET',
              params: {
                action: 'BilledPerMonth',
              },
              ignoreLoadingBar: true,
            },
            customerBillable: {
              method: 'GET',
              params: {
                action: 'CustomerBillable',
              },
              isArray: true,
              ignoreLoadingBar: true,
            },
            copy: {
              method: 'POST',
              params: {
                action: 'Copy',
              },
              isArray: true,
            },
            number: {
              method: 'POST',
              params: {
                action: 'Post',
              },
              false: true,
            },
            unnumber: {
              method: 'DELETE',
              params: {
                action: 'Unnumber',
              },
              isArray: false,
            },
            credit: {
              method: 'POST',
              params: {
                action: 'Credit',
              },
              isArray: true,
            },
            getMail: {
              method: 'GET',
              params: {
                action: 'Mail',
              },
              isArray: false,
            },
            sendMail: {
              method: 'POST',
              params: {
                action: 'Send',
              },
              isArray: false,
            },
            initEdit: {
              method: 'GET',
              params: {
                action: 'EditFinalizedInvoice',
                id: 'Init',
              },
              isArray: false,
            },
            commitEdit: {
              method: 'GET',
              params: {
                action: 'EditFinalizedInvoice',
                id: 'Commit',
              },
              isArray: false,
            },
            cancelEdit: {
              method: 'GET',
              params: {
                action: 'EditFinalizedInvoice',
                id: 'Cancel',
              },
              isArray: false,
            },
            export: {
              method: 'POST',
              params: {
                action: 'Export',
              },
              isArray: false,
              transformResponse: wrapResponse(),
            },
            markSent: {
              method: 'POST',
              params: {
                action: 'markSent',
              },
              transformResponse: castResponse(Invoice),
            },
            markExported: {
              method: 'POST',
              params: {
                action: 'markExported',
              },
              transformResponse: castResponse(Invoice),
            },
            clearExportStatus: {
              method: 'POST',
              params: {
                action: 'clearExportStatus',
              },
              transformResponse: castResponse(Invoice),
            },
            report: {
              method: 'POST',
              params: {
                action: 'Report',
              },
              cache: false,
            },
            linesReport: {
              method: 'POST',
              params: {
                action: 'LinesReport',
              },
              cache: false,
            },
          },
        );
      }
      case 'invoiceLine': {
        return $resource(
          appUrls.api + '/api/InvoiceLine/:action/:id',
          {
            action: 'Get',
          },
          {
            query: {
              method: 'GET',
              isArray: true,
              transformResponse: castResponse(InvoiceLine),
              cancellable: true,
            },
            update: {
              method: 'PUT',
              params: {
                action: 'Put',
              },
            },
            save: {
              method: 'POST',
              params: {
                action: 'Post',
              },
            },
            reset: {
              method: 'POST',
              params: {
                action: 'Reset',
              },
            },
            discount: {
              method: 'POST',
              params: {
                action: 'Discount',
              },
            },
            delete: {
              method: 'DELETE',
              params: {
                action: 'Delete',
              },
            },
            move: {
              method: 'POST',
              params: {
                action: 'Move',
                up: true,
              },
              isArray: true,
              transformResponse: castResponse(InvoiceLine),
            },
            registrations: {
              method: 'GET',
              params: {
                action: 'Registrations',
              },
              isArray: true,
              transformResponse: castResponse(BillableRegistration),
            },
          },
        );
      }
      case 'invoiceRegistration': {
        return $resource(appUrls.api + '/api/InvoiceRegistration/:action', null, {
          bill: {
            method: 'POST',
            params: {
              action: 'Bill',
            },
            transformResponse: wrapResponse(),
          },
          create: {
            method: 'POST',
            url: appUrls.api + '/api/InvoiceRegistration/Create/:invoiceId',
            transformRequest: convertDateToString(),
          },
          update: {
            method: 'PUT',
            url: appUrls.api + '/api/InvoiceRegistration/Put/:invoiceId',
            transformRequest: convertDateToString(),
          },
          billRegistrations: {
            method: 'POST',
            params: {
              action: 'POST',
            },
            isArray: true,
          },
          delete: {
            method: 'DELETE',
            url: appUrls.api + '/api/InvoiceRegistration/Delete/:invoiceId/:id',
          },

          changeResource: {
            method: 'PUT',
            url: appUrls.api + '/api/InvoiceRegistration/ChangeResource',
            transformRequest: convertDateToString(),
          },
        });
      }
      case 'draftInvoice': {
        return $resource(
          appUrls.api + '/api/DraftInvoice/:id',
          {
            id: '@id',
          },
          {
            query: {
              method: 'GET',
              isArray: true,
              url: appUrls.api + '/api/DraftInvoice/DraftInvoices',
              transformResponse: castResponse(DraftInvoice),
              cancellable: true,
            },
            get: {
              method: 'GET',
              isArray: false,
              url: appUrls.api + '/api/DraftInvoice/:id',
              transformResponse: castResponse(DraftInvoice),
            },
            update: {
              method: 'PUT',
              isArray: false,
              transformRequest: convertDateToUtcString(),
              transformResponse: castResponse(DraftInvoice),
            },
            recalculateDiscounts: {
              method: 'GET',
              url: appUrls.api + '/api/DraftInvoice/RecalculateDiscounts/:id',
              isArray: false,
              transformResponse: wrapResponse(),
            },
            bookyearInfo: {
              method: 'GET',
              url: appUrls.api + '/api/DraftInvoice/BookyearInfo',
              isArray: true,
              ignoreLoadingBar: true,
              cancellable: true,
            },
            info: {
              method: 'GET',
              params: {
                id: 'Info',
              },
              isArray: false,
              ignoreLoadingBar: true,
              cancellable: true,
            },
            report: {
              method: 'POST',
              url: appUrls.api + '/api/DraftInvoice/Report',
              cache: false,
            },
          },
        );
      }
      case 'authorization': {
        return $resource(appUrls.api + '/api/Authorization/:action', null, {
          update: {
            params: {
              action: 'PUT',
            },
            method: 'PUT',
            transformRequest: convertDateToString(),
          },
          save: {
            params: {
              action: 'CreateAuthorization',
            },
            method: 'POST',
            isArray: false,
            transformRequest: convertDateToString(),
            transformResponse: convertDateStringsToDates(),
          },
        });
      }
      case 'relationBankAccount': {
        return $resource(appUrls.api + '/api/RelationBankAccount/:action', null, {
          save: {
            params: {
              action: 'Post',
            },
            method: 'POST',
            isArray: true,
          },
          delete: {
            params: {
              action: 'Delete',
            },
            method: 'DELETE',
            isArray: true,
          },
          domiciliation: {
            params: {
              action: 'Domiciliation',
            },
            method: 'PUT',
            isArray: true,
          },
          pitRefund: {
            params: {
              action: 'PitRefund',
            },
            method: 'PUT',
            isArray: true,
          },
        });
      }

      case 'invoiceSchedule': {
        return $resource(appUrls.api + '/api/InvoiceSchedule/:action', {
          action: 'Get',
        });
      }
      case 'invoiceText': {
        return $resource(appUrls.api + '/api/InvoiceText/:action', null, {
          update: {
            method: 'PUT',
            params: {
              action: 'Put',
            },
          },
          get: {
            method: 'GET',
            isArray: true,
            params: {
              action: 'InvoiceTexts',
            },
          },
        });
      }
      case 'invoiceStream': {
        return $resource(
          appUrls.api + '/api/InvoiceStream/:action',
          {
            action: 'Get',
          },
          {
            update: {
              method: 'PUT',
              params: {
                action: 'Put',
              },
              transformRequest: convertDateToString(),
              transformResponse: convertDateStringsToDates(),
            },
            save: {
              method: 'POST',
              params: {
                action: 'Post',
              },
            },
            schedules: {
              method: 'GET',
              params: {
                action: 'Schedule',
              },
              isArray: true,
              transformResponse: convertDateStringsToDates(),
            },
            hasDraftInvoices: {
              method: 'GET',
              params: {
                action: 'InvoiceStreamHasDraftInvoices',
              },
              isArray: false,
            },
            clearActiveSchedule: {
              method: 'DELETE',
              params: {
                action: 'ClearActiveSchedule',
              },
            },
            updateSchedule: {
              method: 'PUT',
              params: {
                action: 'Schedule',
              },
              transformRequest: convertDateToString(),
              transformResponse: convertDateStringsToDates(),
              isArray: false,
            },
            deleteSchedule: {
              method: 'DELETE',
              params: {
                action: 'DeleteSchedule',
              },
            },
            getResources: {
              method: 'GET',
              params: {
                action: 'Resources',
              },
              isArray: true,
            },
            saveResources: {
              method: 'POST',
              params: {
                action: 'Resources',
              },
              isArray: false,
            },
            invoiceStreams: {
              method: 'GET',
              params: {
                action: 'InvoiceStreams',
              },
              isArray: true,
              transformRequest: convertDateToString(),
              transformResponse: convertDateStringsToDates(),
            },
            unsettledAdvances: {
              method: 'GET',
              params: {
                action: 'UnsettledAdvances',
              },
              isArray: false,
            },
          },
        );
      }
      case 'plannedRegistration': {
        return $resource(
          appUrls.api + '/api/PlannedRegistration/:action',
          {
            action: 'Get',
          },
          {
            query: {
              method: 'GET',
              params: {
                action: 'Get',
              },
              transformResponse: convertDateStringsToDates(),
              isArray: true,
            },
            delete: {
              method: 'DELETE',
              params: {
                action: 'Delete',
              },
            },
            update: {
              method: 'PUT',
              params: {
                action: 'Put',
              },
              transformRequest: convertDateToString(),
              transformResponse: convertDateStringsToDates(),
            },
            save: {
              method: 'POST',
              params: {
                action: 'Post',
              },
              transformRequest: convertDateToString(),
              transformResponse: convertDateStringsToDates(),
            },
            schedules: {
              method: 'GET',
              params: {
                action: 'Schedules',
              },
              isArray: true,
              transformRequest: convertDateToString(),
              transformResponse: convertDateStringsToDates(),
            },
            scheduleLines: {
              method: 'GET',
              params: {
                action: 'Schedule',
                id: null,
              },
              isArray: true,
              transformRequest: convertDateToString(),
              transformResponse: convertDateStringsToDates(),
            },
            updateSchedule: {
              method: 'PUT',
              params: {
                action: 'Schedule',
              },
              transformRequest: convertDateToString(),
              transformResponse: convertDateStringsToDates(),
              isArray: false,
            },
            deleteSchedule: {
              method: 'DELETE',
              params: {
                action: 'DeleteSchedule',
              },
            },
          },
        );
      }
      default: {
        console.warn("The resourceFactory doesn't support the type " + type + '.');
        return null;
      }
    }
  };

  return {
    get: getResource,
    transformDate: transformDate,
    setDatePropsToISO: setDatePropsToISO,
  };
}
